import React, { useState, useEffect } from "react";
import auctionService from "../../services/auction/auction.service";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import ErrorHandler from "../../common/ErrorHandler";
import { errorToast, successToast } from "../../react-toastfiy/toast";

function MetaportalModal(props) {
    const { onHide, id, removeFinancierIdList } = props;
    const [selectedFinancierType, setSelectedFinancierType] = useState(null);
    const [FinancierList, setFinancierList] = useState(null);
    const [productionKey, setProductionKey] = useState(null);
    const [UATKey, setUATKey] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [financierLoading, setFinancierLoading] = useState(false);

    useEffect(() => {
        try {
            setFinancierLoading(true);
            auctionService.GetBrand()
                .then((res) => {
                    if (res?.status === 200) {
                        setFinancierList(
                            res?.data
                                ?.filter((item) => !removeFinancierIdList?.includes(item.brand_id))
                                ?.map((item) => ({
                                    label: item.name,
                                    value: item.brand_id,
                                }))
                        );
                    } else {
                        setFinancierList([]);
                    }
                    setFinancierLoading(false);
                });
        } catch (error) {
            setFinancierLoading(false);
            errorToast(error?.message);
        }
    }, []);

    useEffect(() => {
        if (id) {
            try {
                setIsLoading(true);
                const formdata = new FormData();
                formdata.append("id", id);
                auctionService.GetAPIKeyById(formdata)
                    .then((res) => {
                        if (res?.status === 200) {
                            setSelectedFinancierType({
                                label: res?.data?.brand_name,
                                value: res?.data?.brand_id,
                            });
                            setProductionKey(res?.data?.prod_key || "");
                            setUATKey(res?.data?.uat_key === "" || res?.data?.uat_key === "-" ? "" : res?.data?.uat_key);
                        } else {
                            errorToast(res?.msg);
                        }
                        setIsLoading(false);
                    });
            } catch (error) {
                setIsLoading(false);
                errorToast(error?.message);
            }
        }
    }, []);


    const handleChange = (value) => {
        setSelectedFinancierType(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setBtnLoading(true);
            const formdata = new FormData();
            formdata.append("brand_id", selectedFinancierType.value);
            formdata.append("prod_key", productionKey);
            formdata.append("uat_key", UATKey || "");
            if (id) {
                formdata.append("id", id);
            }
            let res;
            if (id) {
                res = await auctionService.UpdateAPIKey(formdata);
            } else {
                res = await auctionService.CreateAPIKey(formdata);
            }
            setBtnLoading(false);
            if (res?.status === 200) {
                successToast(`API Key ${id ? 'Updated' : 'Added'} Successfully`);
                onHide();
            } else {
                errorToast(res?.msg);
            }
        } catch (error) {
            setBtnLoading(false);
            errorToast(error?.message);
        }
    };

    try {
        return (
            <Modal
                {...props}
                size="md"
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <div>
                        <h5>Add New Key</h5>
                    </div>
                </Modal.Header>
                <form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <span className="d-inline-block w-100 mb-2">
                            <label>Financier Name</label>
                            <Select
                                id="financierType"
                                name="financierType"
                                placeholder="Select financier type.."
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: "14px",
                                        color: "#6c757d",
                                    }),
                                }}
                                openMenuOnFocus={false}
                                isDisabled={financierLoading || id}
                                openMenuOnClick={true}
                                closeMenuOnSelect={true}
                                closeMenuOnScroll={(event) => {
                                    // Close menu when modal body scrolls
                                    return event.target.closest(".modal-body") !== null;
                                }}
                                options={FinancierList}
                                onChange={handleChange}
                                required
                                value={selectedFinancierType}
                            />
                        </span>
                        <label className="mt-2">Production Key</label>
                        <input
                            type="text"
                            className="form-control"
                            onChange={(e) => setProductionKey(e.target.value)}
                            value={productionKey}
                            placeholder="Enter Production Key"
                            name="Production_key"
                            disabled={isLoading}
                            required
                        />
                        <label className="mt-3">UAT Key</label>
                        <input
                            type="text"
                            className="form-control"
                            onChange={(e) => setUATKey(e.target.value)}
                            placeholder="Enter UAT Key"
                            disabled={isLoading}
                            value={UATKey}
                            name="uat_key"
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        {btnLoading ? (
                            <Button variant="success" disabled>
                                <span
                                    className="spinner-border spinner-border-sm me-1"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                Loading...
                            </Button>
                        ) : (
                            <Button type="submit" className="btn-success" disabled={financierLoading || isLoading}>
                                {id ? 'Edit Key' : 'Add Key'}
                            </Button>
                        )}
                    </Modal.Footer>
                </form>
            </Modal>
        );
    } catch (error) {
        return <ErrorHandler error={error} />;
    }
}

export default MetaportalModal;
